<div class="row" [ngClass]="IsHomePageSearch ? '' : 'mobile-margin'">
    <div class="col-lg-8 col-md-8 col-sm-12  searchBg searchMobile">
        <input type="text" class="ellipsis border-left form-control" [ngClass]="Classes" [id]="LocationSelectionId"
            [name]="LocationSelectionName" placeholder="{{PlaceHolder}}" [(ngModel)]="SearchKeywordLocation"
            (input)="OnInput($event)" (keydown)="OnkeyDown($event)" (paste)="OnPasteText($event)"
            on-change="OnSearchLocationChange()" (click)="DisplayAutoCompleteResult()" autocomplete="off" />
        <span *ngIf="ReadCurrentLocation" class="target-icon" title="Get Current Location"><i class="fas fa-crosshairs"
                (click)="OnClickGpsTargetIcon()"></i></span>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12  searchMobile">
        <select class="border-right form-control" id="exampleFormControlSelect1" aria-label="none" [ngClass]="Classes"
            [disabled]="SearchService?.IsRadiusDisabled" [(ngModel)]="SearchService.SearchParams.Radius"
            on-change="OnRadiusChange()">
            <option [value]="0">{{SearchService?.IsRadiusDisabled ? 'Distance' : 'Within?'}}</option>
            <option [value]="1">1 Mile</option>
            <option [value]="2">2 Miles</option>
            <option [value]="5">5 Miles</option>
            <option [value]="10">10 Miles</option>
            <option [value]="15">15 Miles</option>
            <option [value]="20">20 Miles</option>
            <option [value]="25">25 Miles</option>
            <option [value]="30">30 Miles</option>
            <option [value]="40">40 Miles</option>
            <option [value]="50">50 Miles</option>
            <option [value]="60">60 Miles</option>
            <option [value]="70">70 Miles</option>
            <option [value]="100">100 Miles</option>
            <option [value]="1000">Any</option>
        </select>
    </div>
</div>
<div *ngIf="IsSuggest && AutoCompleteOptions">
    <div [ngClass]="IsHomePageSearch ? 'job-opt-home' : 'job-opt'">
        <ul class="list-group" id="autocompletelist">
            <li class="list-group-item" *ngFor="let op of AutoCompleteOptions;let i=index;"
                [class.autocompleteactive]="i == ArrowkeyLocation" (click)="OnOptionSelected(op)">
                {{op.DisplayValue}}
            </li>
        </ul>
    </div>
</div>